class RichText extends HTMLElement {
    constructor() {
        super();

        this.textBlocks = this.querySelectorAll(".rich-text__selling-point");
        this.textBlocks.forEach((textBlock) => {
            textBlock.addEventListener('mouseenter', this.handleHover.bind(this))
        })
    }

    handleHover(event) {
        const index = event.currentTarget.dataset.index;

        this.querySelectorAll("img").forEach((image, i) => {
            if (i == index) {
                image.classList.add("rich-text__images__image--active");
            } else {
                image.classList.remove("rich-text__images__image--active");
            }
        })

        this.querySelectorAll(".rich-text__selling-point__title").forEach(
          (image, i) => {
            if (i == index) {
              image.classList.add("rich-text__selling-point__title--active");
            } else {
              image.classList.remove("rich-text__selling-point__title--active");
            }
          }
        );
    }
}

customElements.define('rich-text', RichText);
